export const hasNoLetters = (text: string | null) => {
	if (text && /[a-zA-Z]/.test(text)) {
		return false
	}
	return true
}
